import {
    DM_Sans,
    Open_Sans,
    Inter,
    Poppins,
    Montserrat,
    Roboto,
    Chivo,
    Fjalla_One,
    Dosis,
    Instrument_Sans,
    Nunito,
    Oswald,
    Outfit,
    Karla,
    Bebas_Neue,
    Playfair_Display,
    Titillium_Web,
    Roboto_Condensed, Assistant, Josefin_Sans,
} from "next/font/google";

import alfakhervape from "@/shops/alfakhervape/config";
import bulknicotinepouches from "@/shops/bulknicotinepouches/config";
import crystalblingvape from "@/shops/crystalblingvape/config";
import immyz from "@/shops/immyz/config";
import nextgenvapes from "@/shops/nextgenvapes/config";
import nicotinebuzz from "@/shops/nicotinebuzz/config";
import noviqdistribution from "@/shops/noviqdistribution/config";
import podvapekits from "@/shops/podvapekits/config";
import puffandgo from '@/shops/puffandgo/config'
import trustedwholesale from "@/shops/trustedwholesale/config";
import vapeblue from "@/shops/vapeblue/config";
import vapecraze from '@/shops/vapecraze/config';
import vapehubonline from "@/shops/vapehubonline/config";
import vapeportwholesale from "@/shops/vapeportwholesale/config";
import vapeswholesale from "@/shops/vapeswholesale/config";
import vapetocart from "@/shops/vapetocart/config";
import vapeuksuperstore from "@/shops/vapeuksuperstore/config";
import vapewholesaleonline from "@/shops/vapewholesaleonline/config";
import vapewholesaleshop from "@/shops/vapewholesaleshop/config";
import vapeyardwholesale from "@/shops/vapeyardwholesale/config";
import vapestonewholesale from "@/shops/vapestonewholesale/config";
import pouchandgo from "@/shops/pouchandgo/config";
import vapestorehub from "@/shops/vapestorehub/config";
import vapourvape from "@/shops/vapourvape/config";
import aspireeciguk from "@/shops/aspireeciguk/config";
import bestvapewholesale from "@/shops/bestvapewholesale/config";
import crystalprime7000 from "@/shops/crystalprime7000/config";
import directvapewholesale from "@/shops/directvapewholesale/config";
import mcrvapedistro from "@/shops/mcrvapedistro/config";
import theno1plug from "@/shops/theno1plug/config";
import topvapewholesale from "@/shops/topvapewholesale/config";
import vapewholesalehub from "@/shops/vapewholesalehub/config";
import wolfvapes from "@/shops/wolfvapes/config";
import vapeukwholesale from "@/shops/vapeukwholesale/config";
import vapeuksupplier from "@/shops/vapeuksupplier/config";
import merseyvapour from "@/shops/merseyvapour/config";
import wishbasket from "@/shops/wishbasket/config";
import hayatipromaxvape from "@/shops/hayatipromaxvape/config";
import vaperdeals from "@/shops/vaperdeals/config";
import bulkvapewholesale from "@/shops/bulkvapewholesale/config";

const shops = {
    alfakhervape,
    aspireeciguk,
    bestvapewholesale,
    bulknicotinepouches,
    bulkvapewholesale,
    crystalblingvape,
    crystalprime7000,
    directvapewholesale,
    hayatipromaxvape,
    immyz,
    mcrvapedistro,
    merseyvapour,
    nextgenvapes,
    nicotinebuzz,
    noviqdistribution,
    podvapekits,
    pouchandgo,
    puffandgo,
    theno1plug,
    topvapewholesale,
    trustedwholesale,
    vapeblue,
    vapecraze,
    vapehubonline,
    vapestorehub,
    vapeportwholesale,
    vaperdeals,
    vapeswholesale,
    vapetocart,
    vapeuksuperstore,
    vapeuksupplier,
    vapeukwholesale,
    vapewholesalehub,
    vapewholesaleonline,
    vapewholesaleshop,
    vapestonewholesale,
    vapeyardwholesale,
    vapourvape,
    wishbasket,
    wolfvapes,
}

export function getShopConfig() {

    const shop = process.env.NEXT_PUBLIC_SHOP_BRANCH

    return shops[shop]
}

export const DEFAULT_PRICING = {
    showVatBreakdown: false,
    vatDisplayFormat: 'both',
}

export function resolvePricing(config) {
    return {...DEFAULT_PRICING, ...config?.pricing}
}

export function getPricingConfig() {
    return resolvePricing(getShopConfig())
}

const dmSans = DM_Sans({
    weight: ["400", "500", '600', "700"],
    variable: "--font-sans",
    style: ["normal"],
    subsets: ["latin"],
    display: "swap",
    preload: true,
});

const inter = Inter({
    subsets: ['latin'],
    weight: ['400', '500', '600', '700'],
    variable: '--font-sans',
    display: 'swap'
});

const chivo = Chivo({
    subsets: ['latin'],
    weight: ['400', '500', '600', '700'],
    variable: '--font-sans',
    display: 'swap'
});

const openSans = Open_Sans({
    subsets: ['latin'],
    weight: ['400', '500', '600', '700'],
    variable: '--font-sans',
    display: 'swap'
});

const josefinSans = Josefin_Sans({
    subsets: ['latin'],
    weight: ['400', '500', '600', '700'],
    variable: '--font-sans',
    display: 'swap'
});

const roboto = Roboto({
    subsets: ['latin'],
    weight: ['400', '500', '600', '700'],
    variable: '--font-sans',
    display: 'swap'
});

const poppins = Poppins({
    subsets: ['latin'],
    weight: ['400', '500', '600', '700'],
    variable: '--font-sans',
    display: 'swap'
});

const montserrat = Montserrat({
    subsets: ['latin'],
    weight: ['400', '500', '600', '700'],
    variable: '--font-sans',
    display: 'swap'
});

const karla = Karla({
    subsets: ['latin'],
    weight: ['400', '500', '600', '700'],
    variable: '--font-sans',
    display: 'swap'
});

const dosis = Dosis({
    subsets: ['latin'],
    weight: ['400', '500', '600', '700'],
    variable: '--font-sans',
    display: 'swap'
});

const instrumentSans = Instrument_Sans({
    subsets: ['latin'],
    weight: ['400', '500', '600', '700'],
    variable: '--font-sans',
    display: 'swap'
});

const outfit = Outfit({
    subsets: ['latin'],
    weight: ['400', '500', '600', '700'],
    variable: '--font-sans',
    display: 'swap'
});

const titilliumWebSans = Titillium_Web({
    subsets: ['latin'],
    weight: ['400','600','700'],
    variable: '--font-sans',
    display: 'swap'
});

//heading Fonts

const nunito = Nunito({
    subsets: ['latin'],
    weight: ['400', '500', '600', '700'],
    variable: '--font-heading',
    display: 'swap'
});

const montHeading = Montserrat({
    subsets: ['latin'],
    weight: ['400', '500', '600', '700'],
    variable: '--font-heading',
    display: 'swap'
});

const playfairDisplay = Playfair_Display({
    subsets: ['latin'],
    weight: ['400', '600', '700'],
    variable: '--font-heading',
    display: 'swap'
});

const oswald = Oswald({
    subsets: ['latin'],
    weight: '400',
    variable: '--font-heading',
    display: 'swap'
});

const fjallaOne = Fjalla_One({
    subsets: ['latin'],
    weight: '400',
    variable: '--font-heading',
    display: 'swap'
});

const bebasNeue = Bebas_Neue({
    subsets: ['latin'],
    weight: ['400'],
    variable: '--font-heading',
    display: 'swap'
});

const titilliumWeb = Titillium_Web({
    subsets: ['latin'],
    weight: ['400','600'],
    variable: '--font-heading',
    display: 'swap'
});

const robotoCondensed = Roboto_Condensed({
    subsets: ['latin'],
    weight: ['400','600','700'],
    variable: '--font-heading',
    display: 'swap'
});

const assistant = Assistant({
    subsets: ['latin'],
    weight: ['400','500','600','700'],
    variable: '--font-heading',
    display: 'swap'
});

const dosisHeading = Dosis({
    subsets: ['latin'],
    weight: ['400','500','600','700'],
    variable: '--font-heading',
    display: 'swap'
});

const DEFAULT_FONTS = {
    body: dmSans,
    heading: fjallaOne,
    headingWeight: '400',
};

const shopFonts = {
    aspireeciguk: {body: montserrat, heading: montHeading, headingWeight: '600'},
    bulkvapewholesale: {body: titilliumWebSans, heading: titilliumWeb, headingWeight: '600'},
    crystalprime7000: {body: josefinSans, heading: oswald, headingWeight: '500'},
    theno1plug: {body: instrumentSans, heading: nunito, headingWeight: '700'},
    vapewholesalehub: {body: openSans, heading: fjallaOne},
    vapetocart: {body: karla, heading: titilliumWeb,headingWeight: '600'},
    wishbasket: {body: karla, heading: titilliumWeb,headingWeight: '600'},
    vapecraze: {body: dmSans, heading: fjallaOne,headingWeight: '400'},
    noviqdistribution: {body: openSans, heading: oswald,headingWeight: '500'},
    immyz: {body: poppins, heading: oswald, headingWeight: '500'},
    vapourvape: {body: openSans, heading: fjallaOne},
    wolfvapes: {body: roboto, heading: fjallaOne},
    vapeuksupplier: {body: roboto, heading: oswald, headingWeight: '500'},
    merseyvapour: {body: roboto, heading: oswald, headingWeight: '500'},
    mcrvapedistro: {body: inter, heading: titilliumWeb, headingWeight: '600'},
    bestvapewholesale: {body: inter, heading: titilliumWeb, headingWeight: '600'},
    topvapewholesale: {body: inter, heading: titilliumWeb, headingWeight: '600'},
    vapeukwholesale: {body: montserrat, heading: oswald, headingWeight: '500'},
    directvapewholesale: {body: openSans, heading: robotoCondensed, headingWeight: '700'},
    hayatipromaxvape: {body: dmSans, heading: oswald, headingWeight: '500'},
    vaperdeals: {body: chivo, heading: montHeading, headingWeight: '600'},
}

export function getFontConfig() {
    const shop = process.env.NEXT_PUBLIC_SHOP_BRANCH
    return shopFonts[shop] ?? DEFAULT_FONTS
}